export default "__VITE_ASSET__Cjo6jCmT__"